import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { CtrlBaseComponent } from '../ctrl-base.component';

@Component({
  selector: 'ct-sidebar',
  templateUrl: './ct-sidebar.component.html',
  styleUrls: ['./ct-sidebar.component.css'],
  host: {
    '[id]': 'getId()',
    '[class]': "getStyleClass()"
  }
})
export class CtSidebarComponent extends CtrlBaseComponent {

  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;
  tittle;
  toggled = false;

  constructor() {
    super();
  }

  ngAfterViewInit() {
    this.paintChildren(this.getMetaData(), this.target);
  }

  open(){
    this.toggled = true;
  }

  close(){
    this.toggled = false;
  }

  setTitle(title: string) { this.tittle = title }
  getTitle() { return this.tittle }


}
